
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import {
  IWidgetSettingsFormData,
  WidgetNameIcon
} from '@/models/Widget/settings';
import { EWidgetThemes } from '@/models/Widget/themes';

import Typography from '@/components/atoms/Typography/Typography.vue';
import WidgetColorSelect from '@/components/atoms/WidgetColorSelect/WidgetColorSelect.vue';
import WidgetIconSelect from '@/components/atoms/WidgetIconSelect/WidgetIconSelect.vue';
import PlacementConfigRadio from '@/components/molecules/PlacementConfigRadio/PlacementConfigRadio.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import { configWidgetFormDataFactory } from '@/views/Onboarding/helpers';

@Component({
  components: {
    Typography,
    FormLabel,
    WidgetColorSelect,
    WidgetIconSelect,
    PlacementConfigRadio
  }
})
export default class WidgetConfigForm extends Vue {
  @Prop() defaultFormData?: IWidgetSettingsFormData;
  @Prop({ default: [] }) errors?: any[];

  formData: IWidgetSettingsFormData =
    this.defaultFormData || configWidgetFormDataFactory();

  get tPrefix() {
    return 'common.components.widgetConfigFormV2';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  setFormData(formData: IWidgetSettingsFormData) {
    this.formData = formData;
  }

  created() {
    eventBus.$on('widgetConfigFormSetFormData', this.setFormData);
  }

  beforeDestroy() {
    eventBus.$off('widgetConfigFormSetFormData', this.setFormData);
  }

  @Watch('formData', { deep: true })
  onChange() {
    this.$emit('change', {
      ...this.formData
    });
  }

  @Watch('formData.enabled')
  canActivate() {
    this.$emit('canActivate', this.formData.enabled);
  }

  getChangedSection(section: string) {
    const sections = this.$store.getters['business/getWidgetWarnChanges'];

    return sections && sections.includes(section);
  }

  handleColor(colorData: { color: EWidgetThemes }) {
    this.formData.widgetStyle.color = colorData.color;
  }

  handleIcon(iconData: { icon: WidgetNameIcon }) {
    this.formData.widgetStyle.icon = iconData.icon;
    this.formData.previewState = 'welcomeMessage';
  }
}
